<template>
  <scout-form
    :is-modified="!!value"
    label="他社からのスカウト受け取り数"
    half
  >
    <div class="boss-layout boss-layout-start">
      <div>
        <select
          :value="value"
          class="boss-input-select"
          data-test="select-changed-jobs"
          @change="$emit('input', $event.target.value || null)"
        >
          <option
            value=""
          >
            指定なし
          </option>
          <option
            v-for="option in options"
            :key="option.id"
            :value="option.value"
            :data-test="`option-${option.id}`"
          >
            {{ option.name }}
          </option>
        </select>
      </div>
      <div>
        <div class="boss-annotation-text">
          ※7日以内にスカウトを受けた企業数で絞り込みます。
        </div>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import * as definition from '@/lib/labelValueMappings'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  data () {
    return {
      options: [...definition.approachedOtherCompany]
    }
  }
}
</script>
